import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Close from "@material-ui/icons/Close";
import { toggleCart, goToCheckout } from "../../actions";
import OrderItem from "../OrderItem";
import styles from "./styles";
import { Button } from "../Buttons";

import { getCartSubtotal } from "../../reducers";

class Cart extends Component {
  onCheckoutClick = () => {
    this.props.onClose();
    this.props.goToCheckout();
  };
  render() {
    const { classes, open, onClose, cartItems, subtotal } = this.props;
    return (
      <Drawer anchor="right" open={open} onClose={onClose}>
        <div className={classes.container}>
          <p className={classes.header}>Cart</p>
          <div className={classes.details}>
            {cartItems.length === 0 && (
              <p className={classes.emptyMessage}>Your cart is empty.</p>
            )}
            {cartItems.map(cartItem => (
              <OrderItem
                key={`${cartItem.productId}-${cartItem.optionId}`}
                {...cartItem}
              />
            ))}
          </div>
          <hr className="divider" />
          <div className={classes.row}>
            <p>Subtotal</p>
            <p>${subtotal}</p>
          </div>
          <Button
            variant="contained"
            size="large"
            fullWidth={true}
            onClick={this.onCheckoutClick}
          >
            Checkout
          </Button>
          <Close className={classes.closeBtn} onClick={onClose} />
        </div>
      </Drawer>
    );
  }
}
const mapStateToProps = state => ({
  open: state.cart.open,
  cartItems: state.cart.cartItems,
  subtotal: getCartSubtotal(state)
});
Cart.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  goToCheckout: PropTypes.func.isRequired
};
Cart = connect(
  mapStateToProps,
  {
    onClose: () => toggleCart(false),
    goToCheckout
  }
)(Cart);

export default withStyles(styles)(Cart);



// WEBPACK FOOTER //
// ./src/components/Cart/index.js